<template>
  <div>
    <EveryoneHasAnsweredForSlide :key="`${slideActive.id}-${slideActive.version}`" v-if="slideActive.id" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import config from '@/config'
import EveryoneHasAnsweredForSlide from '@/components-v2/presentation-editor/everyone-answered/EveryoneHasAnsweredForSlide.vue'

export default {
  components: {
    EveryoneHasAnsweredForSlide,
  },
  data() {
    return {
      keyPresentationAnswered: '',
    }
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('liveStatsV2', ['liveStatsVersionPrefix']),
  },

  mounted() {
    this.keyPresentationAnswered = `/${this.liveStatsVersionPrefix}/${config.livestatsTopicPrefix}/counting/presentation-${this.presentation.id}/everyone-answered-joined-${this.presentation.version}`

    this.subscribeEveryoneAnsweredAction({
      key: this.keyPresentationAnswered,
      callback: this.handleCounting,
    })
  },
  destroyed() {
    this.unsubscribeEveryoneAnsweredAction(this.keyPresentationAnswered)
    this.clearEveryoneAnsweredPresentationAction()
  },

  methods: {
    ...mapActions([
      'subscribeEveryoneAnsweredAction',
      'unsubscribeEveryoneAnsweredAction',
      'setTotalJoinedPresentationAction',
      'clearEveryoneAnsweredPresentationAction',
    ]),

    handleCounting(topic, msg) {
      if (!msg) return
      const message = JSON.parse(msg)
      this.setTotalJoinedPresentationAction({
        presentationId: this.presentation.id,
        count: message.total,
      })
    },
  },
}
</script>
